var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-navbar',{attrs:{"type":"dark","variant":"dark"}},[_c('b-navbar-brand',{attrs:{"to":"/"}},[_c('img',{attrs:{"width":"32","height":"32","src":require("assets/img/logo.png"),"alt":"Home"}})]),_c('b-navbar-nav',[_vm._t("default")],2),_c('b-navbar-nav',{staticClass:"ml-auto"},[_vm._t("right")],2)],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }